/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';
import { BuilderHlpRoutingModule } from './builder-hlp-routing.module';
import { HlpListBusinessService } from './resources/hlp-list-business.service';
import { HlpListComponent } from './components/hlp-list/hlp-list.component';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),

    BuilderHlpRoutingModule,
  ],
  providers: [
    HlpListBusinessService,
  ],
  declarations: [
    HlpListComponent,
  ],
})

export class BuilderHlpModule {
}
